var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonTypeContent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1109 10H17.8891C12.4362 10 8 14.4355 8 19.8884V79.6718C8 85.1247 12.4362 89.5602 17.8891 89.5602H82.1109C87.5638 89.5602 92 85.1247 92 79.6718V19.8891C92.0007 14.4362 87.5638 10 82.1109 10ZM87.7589 79.6718C87.7589 82.7853 85.2251 85.3184 82.1116 85.3184H17.8891C14.7756 85.3184 12.2418 82.7853 12.2418 79.6718V34.6895H87.7589V79.6718ZM87.7589 30.4477H12.2418V19.8891C12.2418 16.7756 14.7756 14.2425 17.8891 14.2425H82.1109C85.2244 14.2425 87.7582 16.7756 87.7582 19.8891V30.4477H87.7589Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8951 20.8311H18.7205V25.0729H24.8951V20.8311Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8824 20.8311H28.7078V25.0729H34.8824V20.8311Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8712 20.8311H38.6965V25.0729H44.8712V20.8311Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6453 73.6996H38.4652C39.6366 73.6996 40.5861 72.7501 40.5861 71.5787V47.7772C40.5861 46.6057 39.6366 45.6562 38.4652 45.6562H20.6453C19.4739 45.6562 18.5244 46.6057 18.5244 47.7772V71.5787C18.5244 72.7501 19.4739 73.6996 20.6453 73.6996ZM22.7662 49.8981H36.3443V69.4578H22.7662V49.8981Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8593 47.6592H45.2996V51.901H64.8593V47.6592Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0001 57.5576H45.2996V61.7994H79.0001V57.5576Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0001 67.4561H45.2996V71.6979H79.0001V67.4561Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonTypeContent);
export default __webpack_public_path__ + "static/media/lesson_type_content.4af8a62e8c3e4d308945d13701f6f82b.svg";
export { ForwardRef as ReactComponent };